export class ThdInput {
    public topologyId: string;
    public startDate: string;
    public endDate: string;
}